__turbopack_context__.v({
  "addressInfo": "shop-card-module-scss-module__-i6Bda__addressInfo",
  "app_light_theme": "shop-card-module-scss-module__-i6Bda__app_light_theme",
  "deliveryBlockInfo": "shop-card-module-scss-module__-i6Bda__deliveryBlockInfo",
  "description": "shop-card-module-scss-module__-i6Bda__description",
  "inner": "shop-card-module-scss-module__-i6Bda__inner",
  "moreButton": "shop-card-module-scss-module__-i6Bda__moreButton",
  "name": "shop-card-module-scss-module__-i6Bda__name",
  "workShedule": "shop-card-module-scss-module__-i6Bda__workShedule",
});
